import { useEffect, useState } from "react";
import { Button, Checkbox, DatePicker, Form } from "antd";
import moment from "moment";
import { RiFilterOffLine } from "react-icons/ri";
import AutolineNote from "../../components/shared/AutolineNote";
import { BsCalendarCheck, BsChevronRight, BsWallet2 } from "react-icons/bs";
import { REACT_APP_ARPS_BASE_URL } from "../../utils/urls";
import getServiceHistory from "../../utils/getServiceHistory";

import YealyChart from "./components/YealyChart";
import MonthlyChart from "./components/MonthlyChart";
import WeeklyChart from "./components/WeeklyChart";
import formatShort from "../../utils/formatShort";
import { FaCaretDown, FaCaretUp } from "react-icons/fa";
import RevenueByOprt from "./components/RevenueByOprt";
import OperatorDetails from "./components/OperatorDetails";

const { RangePicker } = DatePicker;

export default function Analytics() {
  const [isLoading, setLoading] = useState(false);

  const start = moment().startOf("isoWeek").format("YYYYMMDD");
  const end = moment().endOf("isoWeek").format("YYYYMMDD");
  const [startDate, setStateDate] = useState(start);
  const [endDate, setEndDate] = useState(end);
  const [showRange, setShowRange] = useState(false);
  const [showConsultants, setShowConsultants] = useState(false);
  const [selected, setSelected] = useState({ id: 1, name: "Weekly" });
  const [services, setServices] = useState<any>([]);

  const currentyear = new Date().getFullYear();
  const pastYear = currentyear - 4;

  const [form] = Form.useForm();

  const fetchServices = async () => {
    setLoading(true);
    const response = await fetch(
      `${REACT_APP_ARPS_BASE_URL}/service?start=${startDate}&end=${endDate}`
    );
    const data = await response.json();
    const res = await getServiceHistory(data);
    setServices(data);
    setLoading(false);
  };

  const onDateChange = (date: any) => {
    setStateDate(moment(new Date(date)).format("YYYYMMDD"));
    setEndDate(moment(new Date(date)).format("YYYYMMDD"));
  };

  const onSelectPeriod = (period: any) => {
    if (period?.name === "Weekly") {
      const start = moment().startOf("isoWeek").format("YYYYMMDD");
      const end = moment().endOf("isoWeek").format("YYYYMMDD");
      setStateDate(start);
      setEndDate(end);
    }
    if (period?.name === "Monthly") {
      const start = moment().startOf("year").format("YYYYMMDD");
      const end = moment().endOf("year").format("YYYYMMDD");
      setStateDate(start);
      setEndDate(end);
    }
    if (period?.name === "Yearly") {
      const start = moment().startOf("year").format("YYYYMMDD");
      const end = moment().endOf("year").format("YYYYMMDD");
      setStateDate(start);
      setEndDate(end);
    }
  };

  const onRangeChange = (date: any) => {
    setStateDate(moment(new Date(date[0])).format("YYYYMMDD"));
    setEndDate(moment(new Date(date[1])).format("YYYYMMDD"));
  };

  const clearDate = () => {
    const period = { id: 1, name: "Weekly" };
    form.resetFields();
    const start = moment().startOf("isoWeek").format("YYYYMMDD");
    const end = moment().endOf("isoWeek").format("YYYYMMDD");
    setStateDate(start);
    setEndDate(end);
    setSelected(period);
  };

  const periods = [
    { id: 1, name: "Weekly" },
    { id: 2, name: "Monthly" },
    { id: 3, name: "Yearly" },
  ];

  useEffect(() => {
    fetchServices();
  }, [startDate]);

  return (
    <div className=" bg-gray-100">
      <AutolineNote />
      <div className="flex justify-between items-center border-b  border-gray-300 py-2 mx-4">
        <div className="flex">
          <Form layout="inline" form={form}>
            {showRange ? (
              <div className="flex justify-center items-center">
                <Form.Item name="ranger">
                  <RangePicker
                    allowClear={true}
                    onChange={onRangeChange}
                    format={"DD-MM-YYYY"}
                  />
                </Form.Item>

                <Checkbox onChange={() => setShowRange(!showRange)}>
                  <span className="text-gray-500">Date as Range</span>
                </Checkbox>
              </div>
            ) : (
              <div className="flex justify-center items-center">
                <Form.Item name="picker">
                  <DatePicker
                    onChange={onDateChange}
                    format={"DD-MM-YYYY"}
                    placeholder="Specific date"
                  />
                </Form.Item>
                <Checkbox onChange={() => setShowRange(!showRange)}>
                  <span className="text-gray-500">Date as Range</span>
                </Checkbox>
              </div>
            )}
            <Button className="" onClick={() => clearDate()}>
              <RiFilterOffLine color="#6b7280" />
            </Button>
          </Form>
        </div>
        <div className="">
          <div className="flex flex-row">
            {periods.map((period: any, index: number) => (
              <button
                className={`flex justify-center items-center border border-gray-300 py-2 px-4 ml-2 ${
                  selected.id === period.id ? `bg-red-100` : ``
                }`}
                key={index}
                onClick={() => {
                  setSelected(period);
                  onSelectPeriod(period);
                }}
              >
                <span>
                  <BsCalendarCheck />
                </span>
                <span className="ml-2">{period.name}</span>
              </button>
            ))}
          </div>
        </div>
      </div>
      <div className="grid grid-cols-12 gap-x-3 my-2 mx-4">
        <div className="col-span-12 sm:col-span-9 md:col-span-9">
          <div className="grid grid-cols-12 gap-x-3">
            <div className="col-span-12 sm:col-span-3 md:col-span-3 mb-2 sm:mb-0">
              <div className="border border-gray-300 p-4 bg-white rounded-lg flex-col">
                <div className="">Workshop Department</div>
                <div className="flex">
                  <div className="font-bold text-3xl">
                    {formatShort(24500000)}
                  </div>
                  <div className="flex justify-center items-center">
                    <FaCaretUp color="green" />
                    <span className="text-green-600">5 %</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-span-12 sm:col-span-3 md:col-span-3 mb-2 sm:mb-0">
              <div className="border border-gray-300 p-4 bg-white rounded-lg flex-col">
                <div className="">Bodyshop Department</div>
                <div className="flex">
                  <div className="font-bold text-3xl">
                    {formatShort(14500000)}
                  </div>
                  <div className="flex justify-center items-center">
                    <FaCaretUp color="green" />
                    <span className="text-green-600">2 %</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-span-12 sm:col-span-3 md:col-span-3 mb-2 sm:mb-0">
              <div className="border border-gray-300 p-4 bg-white rounded-lg flex-col">
                <div className="">Fastlane 1 & 2 Departments</div>
                <div className="flex">
                  <div className="font-bold text-3xl">
                    {formatShort(8200000)}
                  </div>
                  <div className="flex justify-center items-center">
                    <FaCaretDown color="red" />
                    <span className="text-red-600">5 %</span>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-span-12 sm:col-span-3 md:col-span-3 mb-2 sm:mb-0">
              <div className="border border-gray-300 p-4 bg-white rounded-lg flex-col">
                <div className="">Fastlane 2 & 4 Departments</div>
                <div className="flex">
                  <div className="font-bold text-3xl">
                    {formatShort(4800000)}
                  </div>
                  <div className="flex justify-center items-center">
                    <FaCaretUp color="green" />
                    <span className="text-green-600">3 %</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-span-12 sm:col-span-3 md:col-span-3 mb-2 sm:mb-0">
          <div className="border border-gray-300 p-4 bg-white rounded-lg flex-col">
            <div className="">App Bookings</div>
            <div className="flex">
              <div className="font-bold text-3xl">45</div>
              <div className="flex justify-center items-center">
                <FaCaretUp color="green" />
                <span className="text-green-600">35 %</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-12 gap-x-3 my-2 mx-4">
        <div className="col-span-12 sm:col-span-9 md:col-span-9">
          <div className="h-full flex flex-col justify-between bg-white mb-4 border border-gray-300 rounded-lg p-8">
            <div className="grid grid-cols-12 gap-x-3">
              <div className="col-span-12 sm:col-span-3 md:col-span-3">
                <div className="flex">
                  <div className="">
                    <div className="">
                      <div className="font-bold flex items-center text-2xl text-gray-800 mb-2">
                        <span className="mr-2">
                          <BsCalendarCheck />
                        </span>
                        {selected?.name}
                      </div>
                      <div className="text-gray-600">
                        {selected?.name === "Yearly" ? (
                          <div className="">
                            {pastYear}
                            <span className="mx-2">-</span>
                            {currentyear}
                          </div>
                        ) : (
                          <div className="">
                            {moment(startDate.toString()).format(
                              "MMMM DD, YYYY"
                            )}
                            <span className="mx-2">-</span>
                            {moment(endDate.toString()).format("MMMM DD, YYYY")}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="mt-12">
                      <div className="text-gray-600 mb-2">
                        Total {selected?.name} Revenue
                      </div>
                      <div className="text-gray-800 text-6xl font-bold">
                        {formatShort(94500000)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-span-12 sm:col-span-9 md:col-span-9">
                <div className="-mt-8 pt-10" style={{ height: 350 }}>
                  {selected?.name === "Weekly" && <WeeklyChart />}
                  {selected?.name === "Monthly" && <MonthlyChart />}
                  {selected?.name === "Yearly" && <YealyChart />}
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-x-3 my-2 border-t pt-8">
              <div className="col-span-12 sm:col-span-4 md:col-span-4">
                <div className="flex">
                  <div className="border border-green-600 h-16 w-16 rounded-full flex justify-center items-center">
                    <BsWallet2 size={30} color="#323232" />
                  </div>
                  <div className="ml-4">
                    <div className="text-2xl text-gray-800  font-bold mb-1">
                      {formatShort(42000000)}
                    </div>
                    <div className="text-gray-600">Service Revenue</div>
                  </div>
                </div>
              </div>
              <div className="col-span-12 sm:col-span-4 md:col-span-4">
                <div className="flex">
                  <div className="border border-green-600 h-16 w-16 rounded-full flex justify-center items-center">
                    <BsWallet2 size={30} color="#323232" />
                  </div>
                  <div className="ml-4">
                    <div className="text-2xl text-gray-800  font-bold mb-1">
                      {formatShort(36500000)}
                    </div>
                    <div className="text-gray-600">Parts Revenue</div>
                  </div>
                </div>
              </div>
              <div className="col-span-12 sm:col-span-4 md:col-span-4">
                <div className="flex">
                  <div className="border border-green-600 h-16 w-16 rounded-full flex justify-center items-center">
                    <BsWallet2 size={30} color="#323232" />
                  </div>
                  <div className="ml-4">
                    <div className="text-2xl text-gray-800  font-bold mb-1">
                      {formatShort(16000000)}
                    </div>
                    <div className="text-gray-600">Other Revenue</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-span-12 sm:col-span-3 md:col-span-3 mt-2 sm:mt-0">
          <div className="h-full bg-white mb-4 border border-gray-300 rounded-lg">
            <div className="border-b py-8">
              <div className="font-bold text-lg ml-4 text-gray-600 flex justify-between items-center ">
                <div className="">Top Consultants</div>
                <div className="flex justify-center items-center">
                  <button
                    className="font-thin text-md mr-1"
                    onClick={() => setShowConsultants(true)}
                  >
                    View All
                  </button>
                  <BsChevronRight />
                </div>
              </div>
            </div>
            <div className="">
              <RevenueByOprt
                startDate={startDate}
                endDate={endDate}
                isVisible={showConsultants}
                setVisible={setShowConsultants}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
